import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';
import { spacing } from 'ucl/themes/shared/primitives';

import { useOrderContext } from 'state/order';
import { primitive } from 'styles/constants/primitives';

export const PickupNowEtaIndicator = () => {
  const { pickupDate } = useOrderContext();
  const { formatMessage } = useIntl();

  if (pickupDate) {
    return null;
  }

  return (
    <View style={styles.container}>
      <MaterialIcons name="access-time-filled" size={12} color={primitive.bk.$bbqBrown} />
      <Text style={styles.text}>{formatMessage({ id: 'pickupNowEta' })}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: primitive.$blackOpacity4,
    borderRadius: 5,
    paddingHorizontal: spacing.$2,
    marginLeft: spacing.$1,
    marginTop: spacing['$1.5'],
  },
  text: {
    fontSize: 12,
    color: primitive.bk.$bbqBrown,
    marginLeft: spacing.$1,
    fontFamily: primitive.fontFamily.$body,
    lineHeight: 24,
  },
});
